export default __webpack_public_path__ + "static/media/anniversary-slice.00cbaede.png";